module.exports = __webpack_public_path__ + "static/media/test-execution-time-partial.b2ceb84f.svg";